/**
 * @Author：zsj
 * @Date：2022/03/11
 */
import { createAction } from 'redux-actions'
import ActionTypes from '../action-types'
import { getHomeInfo } from '../../service/api'

const updateHomeDataAction = createAction(ActionTypes.UPDATE_HOME_DATA)


export const getHomeInfoAsync = () => async dispatch => {
    const res = await getHomeInfo()
    dispatch(updateHomeDataAction({ userInfo: res }))
}

export const getHomeInfoSync = () => {
    return updateHomeDataAction({ userInfo: { name: 'zsj_sync' } })
}
